import Link from "next/link";
import FooterChevronLeftIcon from "@/utils/svgIcons/FooterChevronLeftIcon";
import FooterPaymentSection from "./FooterPaymentSection";
import { BiLogoTelegram } from "react-icons/bi";
import { FiMail } from "react-icons/fi";

const links = [
  { href: "/", label: "Home" },
  { href: "/#about", label: "About Us" },
  { href: "/#commission", label: "Commission" },
  { href: "/help-center", label: "Help Center" },
  { href: "/#contact-us", label: "Contact Us" },
];

const FooterLinksSection = () => {
  return (
    <div className=" w-full lg:max-w-100 xl:max-w-169.5 lg:mt-0 mt-10">
      <div className="flex justify-between lg:flex-row flex-col lg:gap-0 gap-10">
        <div className="max-w-[220] w-full">
          <h3 className="text-xl font-bold text-white">Useful Links</h3>

          <ul className="mt-3">
            {links.map(({ href, label }) => (
              <li key={href} className="text-sm text-white">
                <Link className="flex items-center gap-2 py-2.5" href={href}>
                  <FooterChevronLeftIcon />
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="max-w-92.5 w-full">
          <h3 className="text-xl font-bold text-white">Follow Us</h3>
          <p className="text-sm mt-3 text-white">
            Exclusive campaigns, updated news and time-sensitive deals drop here
            first - follow us to stay in the loop!
          </p>

          <div className="flex items-center gap-2.5 mt-5">
            <Link
              rel=""
              // target="_blank"
              className="size-10 grid place-items-center rounded-full transition-all bg-bg12 hover:bg-bg13 text-2xl text-white"
              href="https://t.me/dalal_official"
            >
              <BiLogoTelegram />
            </Link>
            <Link
              rel="noopener noreferrer nofollow"
              className="size-10 grid place-items-center rounded-full transition-all bg-bg12 hover:bg-white hover:text-text5 text-2xl text-white"
              href="mailto:support.bd@dalalaff.com"
            >
              <FiMail />
            </Link>
          </div>
        </div>
      </div>

      <FooterPaymentSection />
    </div>
  );
};

export default FooterLinksSection;
